<template>
    <div class="side-nav expand-lg" id="sidebar">
        <div class="side-nav-inner">
            <div class="nav-logo">
                <router-link class="logo" to="/dashboard/home">
                    <span id="logosuas">
                        <img
                            :src="$store.state.settings.logotipo"
                            alt="Logo SUAS Fácil"
                        />
                    </span>
                </router-link>
            </div>
            <ul class="side-nav-menu scrollable">
                <li class="side-nav-header">
                    <span>{{ $t("General") }}</span>
                </li>
                <router-link
                    v-for="(item, i) in menuList"
                    :key="i"
                    active-class=""
                    :class="item.separate ? 'side-nav-header' : 'nav-item'"
                    :exact-active-class="item.submenu ? '' : 'active'"
                    tag="li"
                    :to="item.url"
                >
                    <a
                        v-if="
                            item.permissions &&
                            item.separate == undefined &&
                            item.submenu == undefined
                        "
                        @click="showSubmenu = false"
                    >
                        <span class="icon-holder">
                            <i :class="item.icon" />
                        </span>
                        <span class="title">{{ $t(item.title) }}</span>
                    </a>
                    <span v-if="item.permissions && item.separate">
                        <span class="title">{{ $t(item.title) }}</span>
                    </span>
                    <a
                        @click="
                            showModalTroca();
                            showSubmenu = false;
                        "
                        v-if="item.show_button"
                    >
                        <span class="icon-holder">
                            <i :class="item.icon" />
                        </span>
                        <span class="title">{{ $t(item.title) }}</span>
                    </a>
                    <a
                        data-toggle="collapse"
                        aria-expanded="false"
                        class="dropdown-toggle"
                        @click="
                            showSubmenu == item.id
                                ? (showSubmenu = false)
                                : (showSubmenu = item.id)
                        "
                        v-if="item.permissions && item.submenu"
                    >
                        <span class="icon-holder">
                            <i :class="item.icon" />
                        </span>
                        <span class="title">
                            <span class="title">{{ $t(item.title) }}</span>
                        </span>
                    </a>
                    <ul
                        class="list-unstyled collapse"
                        v-if="showSubmenu == item.id"
                        :style="`display:${
                            showSubmenu == item.id ? 'block' : 'none'
                        }`"
                    >
                        <router-link
                            v-for="(subitem, s) in item.submenu"
                            :key="s"
                            class="nav-item"
                            tag="li"
                            :to="subitem.url"
                        >
                            <a v-if="subitem.permissions">
                                <span class="icon-holder">
                                    <i :class="subitem.icon" />
                                </span>
                                {{ $t(subitem.title) }}
                            </a>
                        </router-link>
                    </ul>
                </router-link>
                <li v-if="agendamentoAtivo" class="side-nav-header">
                    <span>AGENDAMENTO</span>
                </li>
                <li v-if="podeConfigurarAgendamento" class="nav-item">
                    <a class="dropdown-toggle" role="button" tabindex="0"
                        :aria-expanded="showSubmenu === 'AgendamentoParametros'"
                        @click="alternarParametrosAgendamento"
                        @keydown.enter.prevent="alternarParametrosAgendamento"
                        @keydown.space.prevent="alternarParametrosAgendamento">
                        <span class="icon-holder"><i class="mdi mdi-cogs" /></span>
                        <span class="title">Parâmetros (Agenda)</span>
                    </a>
                    <ul v-show="showSubmenu === 'AgendamentoParametros'"
                        class="list-unstyled">
                        <router-link v-if="$store.state.user.permissions.ParametroLocalController" tag="li" class="nav-item" :to="{ name: 'agendamento.locais' }">
                            <a><span class="icon-holder"><i class="mdi mdi-map-marker" /></span>Parâmetros de Local</a>
                        </router-link>
                        <router-link v-if="$store.state.user.permissions.ParametroServicoController" tag="li" class="nav-item" :to="{ name: 'agendamento.servicos' }">
                            <a><span class="icon-holder"><i class="mdi mdi-wrench" /></span>Parâmetros de Serviço</a>
                        </router-link>
                        <router-link v-if="$store.state.user.permissions.ParametroServicoLocalController" tag="li" class="nav-item" :to="{ name: 'agendamento.servicos-por-local' }">
                            <a><span class="icon-holder"><i class="mdi mdi-cog" /></span>Serviços por Local</a>
                        </router-link>
                        <router-link v-if="$store.state.user.permissions.ParametroGrupoServicoController" tag="li" class="nav-item" :to="{ name: 'agendamento.grupos-servicos' }">
                            <a><span class="icon-holder"><i class="mdi mdi-table" /></span>Grupos por Serviço</a>
                        </router-link>
                    </ul>
                </li>
            </ul>
        </div>
        <modal-formulario />
        <!-- <modal-tecnico-accept /> -->
    </div>
</template>

<script>
export default {
    name: "Sidebar",
    data() {
        return {
            sidebarOpen: false,
            showButtonTroca: false,
            showSubmenu: false,
            menu: [],
            municipio: null,
        };
    },
    mounted() {
		this.$store.dispatch("getMunicipio");
        this.getUnidadesTecnico();
        this.buscarMunicipio();
    },
    watch: {
        '$route.meta.scheduling': {
            immediate: true,
            handler(active) {
                if (active) this.showSubmenu = 'AgendamentoParametros';
            },
        },
    },
    methods: {
        alternarParametrosAgendamento() {
            this.showSubmenu = this.showSubmenu === 'AgendamentoParametros' ? false : 'AgendamentoParametros';
        },
        async buscarMunicipio() {
            this.municipio = this.$store.state.municipio.toLowerCase();
        },
        showModalTroca() {
            localStorage.setItem("changeUnidade", false);
            this.$snack.success({
                button: false,
                text: "Estamos verificando quais as unidades que estão vinculadas a sua conta",
            });
            this.$root.load_change_unidade = true;
            this.$bvModal.show("modal-select_conta");
        },
        getUnidadesTecnico() {
            axios
                .get("api/dashboard/tecnico/get/unidades")
                .then((response) => {
                    let tecnico = response.data.data;
                    tecnico.unidades = tecnico.unidades.filter(
                        (item) => item.status == 1
                    );
                    if (tecnico.unidades.length > 1) {
                        this.showButtonTroca = true;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    computed: {
        podeConfigurarAgendamento() {
            return this.agendamentoAtivo && this.$store.state.user.permissions &&
                (this.$store.state.user.permissions.ParametroLocalController ||
                    this.$store.state.user.permissions.ParametroServicoController ||
                    this.$store.state.user.permissions.ParametroServicoLocalController ||
                    this.$store.state.user.permissions.ParametroGrupoServicoController);
        },
        agendamentoAtivo() {
            const ativo = this.$store.state.settings.agendamento_ativo;
            return ativo === true || ativo === 1 || ativo === '1';
        },
        menuList() {

            console.log("🧠 menuList recalculado | municipio =", this.municipio);
            
            return [
                {
                    url: "/dashboard/home",
                    icon: "mdi mdi-gauge",
                    title: "Dashboard",
                    permissions: true,
                },
                {
                    url: "/gestor/PainelGestorBI",
                    icon: "mdi mdi-chart-areaspline",
                    title: "Painel do Gestor",
                    permissions:
                        (this.$store.state.user.permissions &&
                        this.$store.state.user.permissions.PainelGestorController) ||
                        this.$store.state.user.role_details.name == 'Admin' ||
                        this.$store.state.user.role_details.name == 'TI da Unidade' ||
                        this.$store.state.user.role_details.name == 'Gestor(a)',
                },
                {
                    url: "/dashboard/meusatendimentos",
                    icon: "mdi mdi-ticket-account",
                    title: "Meus Atendimentos",
                    permissions:
                        this.$store.state.user.permissions &&
                        this.$store.state.user.permissions.AtendimentoController &&
                        this.$store.state.user.role_details.name != 'Admin' &&
                        this.$store.state.user.role_details.name != 'User',
                },
                {
                    url: "/dashboard/familias",
                    icon: "mdi mdi-account-group",
                    title: "Família",
                    permissions:
                        this.$store.state.user.permissions &&
                        this.$store.state.user.permissions.FamiliaController,
                },
                {
                    url: "/dashboard/usuarios",
                    icon: "mdi mdi-account",
                    title: "Usuário",
                    permissions:
                        this.$store.state.user.permissions &&
                        this.$store.state.user.permissions["UsuarioController"] &&
                        this.$store.state.user.role_details.name != 'Nível Básico',
                },
                {
                    url: "/dashboard/beneficios",
                    icon: "mdi mdi-account-cash",
                    title: "Benefício",
                    permissions:
                        this.$store.state.user.permissions &&
                        this.$store.state.user.permissions[
                            "BeneficioController"
                        ],
                },
                {
                    url: "/dashboard/acolhimento/unidades",
                    icon: "mdi mdi-hand-heart",
                    title: "Acolhimento",
                    permissions:
                        this.$store.state.user.permissions &&
                        this.$store.state.user.permissions[
                            "AcolhimentoCriancaController"
                        ],
                },
                {
                    url: "/dashboard/oficios",
                    icon: "mdi mdi-file-document-multiple",
                    title: "Ofício",
                    permissions:
                        this.$store.state.user.permissions &&
                        this.$store.state.user.permissions["OficioController"],
                },
                {
                    url: "/dashboard/denuncias",
                    icon: "mdi mdi-shield-alert",
                    title: "Denúncia",
                    permissions:
                        this.$store.state.user.permissions &&
                        this.$store.state.user.permissions[
                            "DenunciaController"
                        ],
                },
                {
                    url: "/dashboard/atividades",
                    icon: "mdi mdi-clipboard-text",
                    title: "Atividade",
                    permissions:
                        this.$store.state.user.permissions &&
                        this.$store.state.user.permissions[
                            "AtividadeController"
                        ],
                },
                {
                    url: "/dashboard/scfv",
                    icon: "mdi mdi-google-circles-extended",
                    title: "SCFV",
                    permissions:
                        this.$store.state.user.permissions &&
                        this.$store.state.user.permissions["ScfvController"],
                },
                {
                    url: "/dashboard/programassociais",
                    icon: "fas fa-hands",
                    title: "Programas Sociais",
                    permissions:
                        this.$store.state.user.permissions &&
                        this.$store.state.user.permissions[
                            "ProgramaSocialController"
                        ],
                },
                {
                    url: "/dashboard/relatorios",
                    icon: "mdi mdi-chart-pie",
                    title: "Relatório",
                    permissions:
                        this.$store.state.user.permissions &&
                        this.$store.state.user.permissions[
                            "RelatorioController"
                        ],
                },
                {
                    url: "/dashboard/mapas",
                    icon: "mdi mdi-map-search",
                    title: "Mapa",
                    permissions:
                        this.$store.state.user.permissions &&
                        this.$store.state.user.permissions["MapaController"],
                },
                {
                    url: "",
                    icon: "",
                    separate: true,
                    title: "Administration",
                    permissions:
                        this.$store.state.user.role_details.name == 'Admin' ||
                        this.$store.state.user.role_details.name == 'TI da Unidade' ||
                        this.$store.state.user.role_details.name == 'Gestor(a)',
                },
                {
                    url: "",
                    icon: "mdi mdi-swap-horizontal",
                    show_button: this.showButtonTroca,
                    title: "Trocar Unidade",
                },
                {
                    url: "",
                    id: "ConfiguracoesSubmenu",
                    icon: "mdi mdi-cogs",
                    title: "Configuração",
                    show: false,
                    submenu: [
                        {
                            url: "/dashboard/admin/settings",
                            icon: "mdi mdi-cogs",
                            title: "Settings",
                            permissions:
                                this.$store.state.user.permissions &&
                                this.$store.state.user.permissions[
                                    "SettingController"
                                ],
                        },
                        {
                            url: "/dashboard/admin/parametros",
                            icon: "mdi mdi-dots-grid",
                            title: "Parâmetro",
                            permissions:
                                this.$store.state.user.permissions &&
                                this.$store.state.user.permissions[
                                    "ConfiguracaoController"
                                ],
                        },
                        {
                            url: "/dashboard/admin/roles",
                            icon: "mdi mdi-shield-lock",
                            title: "Roles",
                            permissions:
                                this.$store.state.user.permissions &&
                                this.$store.state.user.permissions[
                                    "RoleController"
                                ],
                        },
                        {
                            url: "/dashboard/unidades",
                            icon: "mdi mdi-bank-outline",
                            title: "Unidade",
                            permissions:
                                this.$store.state.user.permissions &&
                                this.$store.state.user.permissions[
                                    "UnidadeController"
                                ],
                        },
                        {
                            url: "/dashboard/tecnicos",
                            icon: "mdi mdi-clipboard-account",
                            title: "Equipe SUAS",
                            permissions:
                                this.$store.state.user.permissions &&
                                this.$store.state.user.permissions[
                                    "AdminTecnicoController"
                                ],
                        },
                        {
                            url: "/dashboard/admin/sms",
                            icon: "mdi mdi-message",
                            title: "SMS",
                            permissions:
                                this.$store.state.user.permissions &&
                                this.$store.state.user.permissions[
                                    "TecnicoController"
                                ],
                        },
                        {
                            url: "/dashboard/admin/translations",
                            icon: "mdi mdi-google-translate",
                            title: "Translations",
                            permissions:
                                this.$store.state.user.permissions &&
                                this.$store.state.user.permissions[
                                    "LanguageController"
                                ],
                        },
                        {
                            url: "/dashboard/termos-uso",
                            icon: "mdi mdi-file-document-edit",
                            title: "Termos de Uso",
                            permissions:
                                this.$store.state.user.permissions &&
                                this.$store.state.user.permissions[
                                    "TermosUsoController"
                                ],
                        },
                        {
                            url: "/dashboard/botpress",
                            icon: "mdi mdi-robot",
                            title: "Chat Bot",
                            permissions:
                                this.$store.state.user.permissions &&
                                this.$store.state.user.permissions[
                                    "BotPressController"
                                ],
                        },
                        {
                            url: "/dashboard/admin/tema-dinamico",
                            icon: "mdi mdi-palette",
                            title: "Templates",
                            permissions:
                                this.$store.state.user.permissions &&
                                this.$store.state.user.permissions[
                                    "TermosUsoController"
                                ],
                        }
                    ],
                    permissions:
                        this.$store.state.user.role_details.name == 'Admin' ||
                        this.$store.state.user.role_details.name == 'TI da Unidade' ||
                        this.$store.state.user.role_details.name == 'Gestor(a)',
                },
                {
                    url: "",
                    id: "EnderecoSubmenu",
                    icon: "mdi mdi-map-marker-radius",
                    title: "Endereço",
                    show: false,
                    submenu: [
                        {
                            url: "/dashboard/enderecos/localidades",
                            icon: "mdi mdi-chevron-right",
                            title: "Localidade",
                            permissions:
                                this.$store.state.user.permissions &&
                                this.$store.state.user.permissions[
                                    "LocalidadeController"
                                ],
                        },
                        {
                            url: "/dashboard/enderecos/logradouros",
                            icon: "mdi mdi-chevron-right",
                            title: "Logradouro",
                            permissions:
                                this.$store.state.user.permissions &&
                                this.$store.state.user.permissions[
                                    "LogradouroController"
                                ],
                        },
                    ],
                    permissions:
                        this.$store.state.user.role_details.name == 'Admin' ||
                        this.$store.state.user.role_details.name == 'TI da Unidade' ||
                        this.$store.state.user.role_details.name == 'Gestor(a)',
                },
                {
                    url: "/dashboard/importacao",
                    icon: "mdi mdi-cloud-upload",
                    title: "Importação",
                    permissions: this.$store.state.user.role_details.name == 'Admin',
                },
                {
                    url: "/dashboard/midias",
                    icon: "mdi mdi-movie",
                    title: "Mídias",
                    permissions: this.$store.state.user.role_details.name == 'Admin',
                },
                {
                    url: "/dashboard/auditorias",
                    icon: "mdi mdi-file-search-outline",
                    title: "Auditoria",
                    permissions:
                        this.$store.state.user.permissions &&
                        this.$store.state.user.permissions[
                            "AuditoriaController"
                        ],
                },
                {
                    url: "/dashboard/suportes",
                    icon: "mdi mdi-ticket-account",
                    title: "Suporte",
                    permissions: true,
                },
                {
                    url: "/dashboard/admin/users",
                    icon: "mdi mdi-account-lock",
                    title: "Administrador",
                    permissions: this.$store.state.user.role_details.name == 'Admin',
                },
            ];
        },
    },
};
</script>

<style>
.side-nav {
    top: 0 !important;
}
.logo img {
    max-width: 250px !important;
    padding: 15px !important;
}

@media (max-width: 992px) {
    .side-nav {
        top: 65px !important;
    }
}

#sidebar {
    transition: all 0.3s;
}
#sidebar ul p {
    color: #fff;
    padding: 10px;
}
#sidebar ul li a {
    padding: 10px;
    display: block;
}
#sidebar ul li.active > a,
a[aria-expanded="true"] {
    background: #f7f7f7;
}
#sidebar a[data-toggle="collapse"] {
    position: relative;
}
#sidebar .dropdown-toggle::after {
    display: block;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
}
ul ul a {
    font-size: 14px !important;
    padding-left: 30px !important;
    background: #f7f7f7;
}
</style>
